import fileSelector from '../app/file_selector';

$(document).on('ready turbolinks:load', () => {
  fileSelector({
    uploadButton: $('#student-photo'),
    idInput: $('input#student_photo_resource_id'),
    type: 'student_pics',
    button: $('button#save-student-button'),
  });
});
